import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import moment from "moment";
import { adminBulkLocationUpdateStatus } from "@services/location.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import {
  deleteComplianceReports,
  getComplianceReports,
  updateReport,
} from "@services/reports.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { useParams } from "react-router-dom";
import { Modal, ModalFooter, ModalHeader } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import SimpleReactValidator from "simple-react-validator";
import { formatText } from "@_common/format-text";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { convertDateAsString } from "@_common/date-helpers";
import { deleteExports, downloadSelfComplianceReports } from "@services/import.service";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import {
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
  getSmartFilterCategoryOfLawList,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
} from "@services/list-management.service";
import {
  getChildEntityGroups,
  getEntityGroups,
  getUserEntityGroupsItems,
} from "@services/entity-mapping.service";
import { adminGetUsers } from "@services/users.service";
import ReportsNotfoundPopup from "@components/Page-Not-Found/reports-not-found-popup";
import MoreReportSvgComponent from "../../../../../assets/svg-components/left-menu/more-report";
import RightMenuHeaders from "@components/common/RightMenuHeaders";

interface IComplianceTaskReportProps {}

const RepositoryMasterReports: React.FunctionComponent<IComplianceTaskReportProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [request, setRequest] = useState({
    from_date: null,
    to_date: null,
    country_id: "",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    event_id: "",
    sub_event_id: "",
    executor: "",
    evaluator: "",
    function_head: "",
  });
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();

      getCountriesList();
      getSmartFilterList();
      getHeaderList(paramsObj, 0);
      getExecutorList("");
      getEvaluator("");
      getFunctionHead("");

      getCategoryLawList("", "", "");
      getLegislationList("", "", "");
      getLegislationRuleList("", "", "");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [info, setInfo] = useState({});
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
      report_type: "SELFCOMP_MASTER",
      sortBy: "newest",
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getComplianceReports(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.reports`, []).map((item: object) => ({
            ...item,
            status: getValue(item, `queue_status`, "")
              ? formatText(getValue(item, `queue_status`, ""))
              : "",
            report_formatted: getValue(item, `report_name`, "")
              ? formatText(getValue(item, `report_name`, ""))
              : "",
            created_at: getValue(item, `created_at`, "")
              ? moment(getValue(item, `created_at`, "")).format(
                  "DD MMM YYYY, hh:mm a"
                )
              : "",
            updated_by:
              getValue(item, `user.first_name`, "") +
              " " +
              getValue(item, `user.last_name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState: any = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/add-clientlist/profile/${id}`);
  };
  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // navigate(`/location/detail/${getValue(obj, `original.id`, "")}`);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const handleRemoveRecord = async (deleteId:any) => {
    try {
      const idsArray = Array.isArray(deleteId) ? deleteId : [deleteId];
      let resp = await deleteExports({ ids: idsArray });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getData();
      }
    } catch (error) {
      
    }
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "Report Name",
        accessor: "report_formatted",
        width: 480,
      },
      {
        Header: "Updated By",
        accessor: "updated_by",
        width: 150,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 150,
      },
      {
        Header: "Create At",
        accessor: "created_at",
        width: 150,
      },
      {
        Header: "Download",
        width: 200,
        Cell: ({ row }: any) => {
          return (
            !row.original.is_verified && (
              <>
              <div className="table_download_container">
                <button
                  className="resend-btn d-flex align-items-center"
                  onClick={(e) =>
                    handleDownloadOnClick(
                      getValue(row, `original.report_url`, ""),
                      getValue(row, `original.report_name`, "")
                    )
                  }
                  style={{
                    color: getValue(row, `original.report_url`, "")
                      ? "#1A73E8"
                      : "black",
                  }}
                  disabled={!getValue(row, `original.report_url`, "")}
                >
                  {getValue(row, `original.report_url`, "") ? (
                    <img
                      src="/images/download.svg"
                      className="img-fluid d-block"
                    />
                  ) : getValue(row, `original.status`, "") === "Failed" ? (
                    "Failed"
                  ) : (
                    <img
                      src="/images/clock.svg"
                      className="img-fluid d-block"
                      style={{
                        height: "18px",
                        width: "18px",
                        marginRight: "5px",
                      }}
                    />
                  )}
                  {getValue(row, `original.report_url`, "") ? (
                    "Download"
                  ) : !getValue(row, `original.report_url`, "") &&
                    getValue(row, `original.queue_status`, "") ===
                      "COMPLETED" ? (
                    "URL Not Found"
                  ) : getValue(row, `original.status`, "") === "Failed" ? (
                    ""
                  ) : (
                    <p>Processing</p>
                  )}
                </button>
                {!getValue(row, `original.report_url`, "") &&
                  getValue(row, `original.status`, "") !== "Failed" &&
                  getValue(row, `original.queue_status`, "") !==
                    "COMPLETED" && (
                    <img
                      src="/images/reload.svg"
                      className="img-fluid d-block"
                      style={{
                        height: "22px",
                        width: "22px",
                        marginLeft: "10px",
                      }}
                      onClick={() => getData()}
                    />
                  )}
              </div>

              {getValue(row, `original.queue_status`, "") !== "COMPLETED" ? 
                <button
                  className="resend-btn d-flex align-items-center mt-1"
                  onClick={(e) =>
                    handleRemoveRecord(
                      getValue(row, `original.id`, "")
                    )
                  }
                  style={{ color: "#d7242e" }}
                >
                    <div className="d-flex align-items-center">
                      <img
                        src="/images/close-red.svg"
                        className="img-fluid d-block"
                      />
                      Remove
                    </div>
                </button>
              : ""}
              </>
            )
          );
        },
      },
    ],
    []
  );
  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkLocationUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [resetInput, setResetInput] = useState(false);

  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await deleteComplianceReports({ ids: selectedIDs });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                             Report Add section                             */
  /* -------------------------------------------------------------------------- */
  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);

  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered = obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) {}
  };

  const [peComplianceList, setPeComplianceList] = useState([]);
  const getPEComplianceList = async () => {
    try {
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setPeComplianceList(obj);
      } else {
      }
    } catch (error) {}
  };

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getStatesList = async (countryId: number) => {
    if (countryId) {
      try {
        let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    setResetInput(false);
    try {
      setResetInput(false);
      setCategoryLawLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id: state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterCategoryOfLawList(queryRequest);
      if (resp) {
        setCategoryOfLawList(
          getValue(resp, `data.stateCategoryOfLaw`, []).map((item: object) => ({
            // ...item,
            // id: getValue(item, `category_of_law.id`, ""),
            id: getValue(item, `id`, ""),
            value: getValue(item, `category_of_law.text`, ""),
            label: getValue(item, `category_of_law.text`, ""),
          }))
        );
        setCategoryLawLoading(false);
        setValue(request, `category_of_law_id`, "");
      } else {
        setCategoryLawLoading(false);
      }
    } catch (error) {
      setCategoryLawLoading(false);
    }
    if (!value) {
      setValue(request, `category_of_law_id`, "");
    }
  };

  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id: state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationList(queryRequest);
      if (resp) {
        setLegislationList(
          getValue(resp, `data.legislations`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          }))
        );
        setLegislationLoading(false);
        setValue(request, `legislation_id`, "");
      } else {
        setLegislationLoading(false);
      }
    } catch (error) {
      setLegislationLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_id`, "");
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationRuleLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        legislation_id: legislation_id
          ? legislation_id
          : getValue(request, `legislation_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationRuleList(queryRequest);
      if (resp) {
        setRuleList(
          getValue(resp, `data.legislationRules`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `rule_name`, ""),
            label: getValue(item, `rule_name`, ""),
          }))
        );
        setLegislationRuleLoading(false);
        setValue(request, `legislation_rule_id`, "");
      } else {
        setLegislationRuleLoading(false);
      }
    } catch (error) {
      setLegislationRuleLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_rule_id`, "");
    }
  };

  /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  const [headerList, setHeaderList] = useState([]);
  const [headerLoading, setHeaderLoading] = useState(true);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        // delete params[`checkpoint_id[]`];
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
        if (getValue(list, `length`, 0) > 0) {
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              []
            ).filter(
              (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
            );
            if (_index === index)
              return getEntityList(
                getValue(findNextLevelInfo, `[${0}].id`, ""),
                item.split("_")[0],
                "",
                index
              );
          });
        } else {
          getEntityList(
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            "",
            index
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const getEntityGroupsUponSelection = async (
    paramsObj: object,
    index: number
  ) => {
    let list =
      Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
    if (getValue(list, `length`, 0) > 0) {
      list.map((item: any, _index: number) => {
        let findNextLevelInfo = headerList.filter(
          (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
        );
        if (_index === index)
          return getEntityList(
            getValue(findNextLevelInfo, `[${0}].id`, ""),
            item.split("_")[0],
            "",
            index
          );
      });
    }
  };
  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    id: string,
    entity_parent: any,
    search_text: string,
    index: number
  ) => {
    if (id) {
      let payload = {
        entity_group: id,
        entity_parent: entity_parent,
        limit: 10,
        search_text: search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setChildEntityLoading(true);
      try {
        let resp = await getChildEntityGroups(queryRequest);
        if (resp) {
          levelObj[id] = getValue(resp, `data.entityMapping`, []).map(
            (item: any) => ({
              ...item,
              value: getValue(item, `entity_name`, ""),
              label: getValue(item, `entity_name`, ""),
            })
          );
          setLevelObj({ ...levelObj });
          setChildEntityLoading(false);
        } else {
          setChildEntityLoading(false);
        }
      } catch (error) {
        setChildEntityLoading(false);
      }
    } else {
      // toast.error("You have Reached Maximum Levels");
    }
  };
  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(obj, headerIndex);
      } else {
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(obj, headerIndex);
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChange = (
    val: string,
    entity_group: string,
    parent_level: any,
    index: number
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
          "_"
        )[0]
      : null;

    if (!val) {
      getEntityList(entity_group, entityID, "", index);
      let length = Object.keys(paramsObj).length;
      for (let i = parent_level; i <= length; i++) {
        let id =
          paramsObj[`level${i + 1}`] &&
          paramsObj[`level${i + 1}`].split("_")[1];
        if (id) {
          levelObj[id] = {};
        }
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
      getHeaderList(obj, index);
    } else {
      getEntityList(entity_group, entityID, val, index);
    }
  };
  /* -----------------------------  Executor  ------------------------------ */

  const [executorList, setExecutorList] = useState([]);
  const [executorLoading, setExecutorLoading] = useState(false);
  const [selectedExecutor, setSelectedExecutor] = useState<any>("");
  const getExecutorList = async (search: string) => {
    try {
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      setExecutorLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setExecutorLoading(false);
        setExecutorList(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          }))
        );
      } else {
        setExecutorLoading(false);
      }
    } catch (error) {
      setExecutorLoading(false);
    }
    if (!search) {
      setSelectedExecutor("");
    }
  };

  /* --------------------------------  Evaluator  ------------------------------ */
  const [evaluatorList, setEvaluatorList] = useState([]);
  const [EvaluatorLoading, setEvaluatorLoading] = useState(false);
  const [selectedEvaluator, setSelectedEvaluator] = useState<any>("");
  const getEvaluator = async (search: string) => {
    try {
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      setEvaluatorLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setEvaluatorLoading(false);
        setEvaluatorList(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          }))
        );
      } else {
        setEvaluatorLoading(false);
      }
    } catch (error) {
      setEvaluatorLoading(false);
    }
    if (!search) {
      setSelectedEvaluator("");
    }
  };
  /* -----------------------------  FunctionHead  ------------------------------ */
  const [FunctionHead, setFunctionHead] = useState([]);
  const [FunctionHeadLoading, setFunctionHeadLoading] = useState(false);
  const [selectedFunctionHead, setSelectedFunctionHead] = useState<any>("");
  const getFunctionHead = async (search: string) => {
    try {
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      setFunctionHeadLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setFunctionHeadLoading(false);
        setFunctionHead(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          }))
        );
      } else {
        setFunctionHeadLoading(false);
      }
    } catch (error) {
      setFunctionHeadLoading(false);
    }
    if (!search) {
      setSelectedFunctionHead("");
    }
  };
  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `state_id`, "");
        setRequest({
          ...request,
          // state_id: "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? e.id : "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", e.id, "");
        getLegislationList("", e.id, "");
        setCategoryOfLawList([]);
        setLegislationList([]);
        setRuleList([]);
      }
    }
    if (type === "category_of_law_id") {
      setRequest({
        ...request,
        category_of_law_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "legislation_id") {
      getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
      setRequest({
        ...request,
        legislation_id: getValue(e, `id`, "") ? e.id : "",
        legislation_rule_id: "",
      });
    }
    if (type === "legislation_rule_id") {
      setRequest({
        ...request,
        legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "executor") {
      setRequest({
        ...request,
        executor: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "evaluator") {
      setRequest({
        ...request,
        evaluator: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "function_head") {
      setRequest({
        ...request,
        function_head: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };
  const handleChangeSelectByValue = (e: object, name: string) => {
    setRequest({
      ...request,
      [name]: getValue(e, `value`, "") ? getValue(e, `value`, "") : "",
    });
  };
  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds)
    );
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
      }
    }
    // if (
    // 	getValue(request, `country_id`, "")
    // 	// getValue(request, `state_id`, "")
    // 	// && getValue(request, `category_of_law_id`, "") &&
    // 	// getValue(request, `legislation_id`, "") &&
    // 	// getValue(request, `legislation_rule_id`, "")
    // ) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: params.page_no,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      legislation_id: getValue(request, `legislation_id`, ""),
      legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
      event_id: getValue(request, `event_id`, ""),
      sub_event_id: getValue(request, `sub_event_id`, ""),
      executor: getValue(request, `executor`, ""),
      evaluator: getValue(request, `evaluator`, ""),
      function_head: getValue(request, `function_head`, ""),
      compliance_status: getValue(request, `compliance_status`, ""),

      smart_filter_tags:
        selectedSmartFilterIdsPayload.length > 0
          ? selectedSmartFilterIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
    };
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    navigate(`${window.location.pathname}?${queryRequest}`);
    // } else {
    // 	toast.error("All fields are mandatory");
    // }
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, "")
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );
  let cat_ID: any =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, "")
    );
  let leg_ID: any =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, "")
    );
  let rule_ID: any =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_rule_id`, "")
    );
  let executor_ID: any =
    getValue(executorList, `length`, 0) > 0 &&
    executorList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `executor`, "")
    );
  let evaluator_ID: any =
    getValue(evaluatorList, `length`, 0) > 0 &&
    evaluatorList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `evaluator`, "")
    );
  let function_head_ID: any =
    getValue(FunctionHead, `length`, 0) > 0 &&
    FunctionHead.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `function_head`, "")
    );
  // let compliance_status_ID =
  //   getValue(complianceStatusOptions, `length`, 0) > 0 &&
  //   complianceStatusOptions.filter(
  //     (item: object) =>
  //       getValue(item, `value`, "") ==
  //       getValue(request, `compliance_status`, "")
  //   );

  /* -------------------------------------------------------------------------- */
  /*                             Report Add section                             */
  /* -------------------------------------------------------------------------- */

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);

  const [isOpen, setIsOpen] = useState<any>(false);
  const handleAddFun = () => {
    handleModal();
  };
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        setSubmitLoading(true);
        let obj = JSON.parse(JSON.stringify(request));
        let levelObj: any = {};
        let lengthOfLevels = Object.keys(paramsObj).length;
        for (let i = 0; i < lengthOfLevels; i++) {
          levelObj[`level_${i + 1}`] = paramsObj[`level${i + 1}`]
            ? parseInt(paramsObj[`level${i + 1}`].split("_")[0])
            : "";
        }
        let payload: any = {
          from_date: moment(getValue(obj, `from_date`, "")).format(
            "YYYY-MM-DD"
          ),
          to_date: moment(getValue(obj, `to_date`, "")).format("YYYY-MM-DD"),
          report_type: "SELFCOMP_MASTER",
          report_name: (
            convertDateAsString(getValue(obj, `from_date`, "")) +
            " " +
            "to" +
            " " +
            convertDateAsString(getValue(obj, `to_date`, ""))
          ).toString(),
          executor: getValue(selectedExecutor, `id`, ""),
          evaluator: getValue(selectedEvaluator, `id`, ""),
          function_head: getValue(selectedFunctionHead, `id`, ""),
          country_id: getValue(request, `country_id`, ""),
          state_id: getValue(request, `state_id`, ""),
          category_of_law_id: getValue(request, `category_of_law_id`, ""),
          legislation_id: getValue(request, `legislation_id`, ""),
          legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
          event_id: getValue(request, `event_id`, ""),
          sub_event_id: getValue(request, `sub_event_id`, ""),
        };
        Object.keys(payload).forEach((key) => {
          if (!payload[key] || payload[key] === undefined) {
            delete payload[key];
          }
        });
        let resp = await downloadSelfComplianceReports({
          ...payload,
          ...levelObj,
        });
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          getData();
          handleModal();
          setRequest({
            ...request,
            from_date: null,
            to_date: null,
            country_id: "",
            state_id: "",
            category_of_law_id: "",
            legislation_id: "",
            legislation_rule_id: "",
            event_id: "",
            sub_event_id: "",
            executor: "",
            evaluator: "",
            function_head: "",
          });
          setSelectedEvaluator("");
          setSelectedExecutor("");
          setSelectedFunctionHead("");
          setParamsObj({});
          simpleValidator.current.hideMessages();
          forceUpdate(0);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "report_analytics_self_compliance"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={false}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={false}
              handleRemoveNavItems={handleRemoveNavItems}
              delete={
                getValue(props, `permissions`, []).includes("delete")
                  ? true
                  : false
              }
              handleDeleteFun={handleDeleteFun}
            />
          )}
          {/* <div className="dashboard-wrapper__header d-flex">
            <NavLink
              to="/report/self-compliance-reports"
              className="user-details-wrapper__header-back-link"
            >
              <img src="/images/back-link.svg" className="img-fluid" />
            </NavLink>
            <h4 className="dashbaord-wrapper__header-title ms-3">
              Master Reports
            </h4>
          </div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <NavLink
                to="/report/self-compliance-reports"
                className="user-details-wrapper__header-back-link me-2"
              >
                <img src="/images/back-link.svg" className="img-fluid" />
              </NavLink>
              <div className="header-parent-icon-holder">
                <MoreReportSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Self Compliance Reports
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Master Reports</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                route={"/report/vendor-audit/add"}
                handleAddFun={() => handleAddFun()}
                isAdd={
                  getValue(props, `permissions`, []).includes("create")
                    ? true
                    : false
                }
                add={
                  getValue(props, `permissions`, []).includes("create")
                    ? "true"
                    : "false"
                }
              />
            </div>
          </div>
          
          <div
            className={`main-page-layout-wrapper`}
            id={
              getValue(selectedIDs, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
          <div className="admin-wrapper position-relative">
            <div className="admin-wrapper position-relative d-none">
              <SearchHeader
                route={"/report/vendor-audit/add"}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                smartFilter={false}
                locationUpload={true}
                search={"false"}
                handleAddFun={() => handleAddFun()}
                isAdd={
                  getValue(props, `permissions`, []).includes("create")
                    ? true
                    : false
                }
                add={
                  getValue(props, `permissions`, []).includes("create")
                    ? "true"
                    : "false"
                }
              />
            </div>
            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : list.length > 0 ? (
              <ScrollableReactTable
                columns={columns}
                data={list}
                getTableState={getTableState}
                rowClick={rowClick}
                check={check}
                selectedIDs={selectedIDs}
                checkboxlogo
                getTrProps={getTrProps}
              />
            ) : (
              <>
                {Object.keys(params).length !== 0 ? (
                  <>
                    <ReportsNotfoundPopup handleAddFun={() => handleAddFun()} />
                  </>
                ) : (
                  <ReportsNotfoundPopup handleAddFun={() => handleAddFun()} />
                )}
              </>
            )}
          </div>
          <div className="footer-wrapper d-flex justify-content-between">
            {list.length > 0 && (
              <img
                src="/images/building-illustration.svg"
                className="img-fluid"
              />
            )}
            {totalCount > 10 ? (
              <PaginationPage
                totalCount={totalCount}
                limit={limit}
                pageNumber={page_no}
                handleChangePagination={handleChangePagination}
                handleChangeLimit={handleChangeLimit}
              />
            ) : (
              <p className="show-rows-count mt-3 d-flex">
                Total Count:&nbsp;&nbsp;{" "}
                <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
              </p>
            )}
          </div>
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />

          <Modal
            isOpen={isOpen}
            toggle={isOpen}
            className="repository_master_popup"
          >
            <ModalHeader>
              <h5> Repository Master Report</h5>
            </ModalHeader>

            <div className="d-flex mt-3 justify-content-around p-2">
              <div className="">
                <div className=" form-group">
                  <label htmlFor="title" className="rolls-label">
                    Start Date <span>*</span>
                  </label>
                  <InputField
                    inputType={"DATETYPE-DOB"}
                    value={getValue(request, `from_date`, "")}
                    className="form-control"
                    label={"Start Date"}
                    onChange={(e: any) =>
                      setRequest({
                        ...request,
                        from_date: e,
                      })
                    }
                    // minDate={tomorrow}
                    placeholderText="Enter Start Date"
                    validator={simpleValidator}
                    maxDate={new Date()}
                  />
                </div>
                <div className=" form-group">
                  <label htmlFor="title" className="rolls-label">
                    End Date <span>*</span>
                  </label>
                  <InputField
                    inputType={"DATETYPE-DOB"}
                    value={getValue(request, `to_date`, "")}
                    className="form-control"
                    onChange={(e: any) =>
                      setRequest({
                        ...request,
                        to_date: e,
                      })
                    }
                    label={"End Date"}
                    placeholderText="Enter End Date"
                    maxDate={new Date()}
                    minDate={getValue(request, `from_date`, "")}
                    validator={simpleValidator}
                  />
                </div>
                <div className="filter-form-wrappper__location flex-2">
                  <div className="filter-form-wrappper__location-form-group form-group">
                    <label
                      htmlFor="country"
                      className="filter-form-wrappper__label"
                    >
                      Country
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Choose Country"
                        className="form-control w-100"
                        name="country_id"
                        id="country_id"
                        options={countryList}
                        value={country_ID}
                        onChange={(e: any) =>
                          handleChangeSelect(e, "country_id")
                        }
                        label="Country"
                      />
                    </div>
                  </div>
                  <div className="filter-form-wrappper__location-form-group form-group">
                    <label
                      htmlFor="state"
                      className="filter-form-wrappper__label"
                    >
                      State
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Choose State"
                        className="form-control w-100"
                        name="state_id"
                        id="state_id"
                        label="Last Name"
                        options={states}
                        value={state_ID}
                        onChange={(e: any) => handleChangeSelect(e, "state_id")}
                        isClear
                      />
                    </div>
                  </div>
                  <div className="filter-form-wrappper__location-form-group form-group">
                    <label
                      htmlFor="law"
                      className="filter-form-wrappper__label"
                    >
                      Category of Law
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <SearchableDropdownSelect
                        placeholder={"Choose Category of Law"}
                        options={categoryOfLawList}
                        searchLoading={categoryLawLoading}
                        handleChange={(val: any) =>
                          getCategoryLawList(val, "", "")
                        }
                        handleClick={(e: any) =>
                          handleChangeSelect(e, "category_of_law_id")
                        }
                        value={getValue(cat_ID, `[${0}]`, {})}
                        label="label"
                        id="id"
                        name="Category of Law"
                        resetInput={resetInput}
                      />
                    </div>
                  </div>
                  <div className="filter-form-wrappper__location-form-group form-group">
                    <label
                      htmlFor="legislation"
                      className="filter-form-wrappper__label"
                    >
                      Legislation
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <SearchableDropdownSelect
                        placeholder={"Choose Legislation"}
                        options={legislationList}
                        searchLoading={legislationLoading}
                        handleChange={(val: any) =>
                          getLegislationList(val, "", "")
                        }
                        handleClick={(e: any) =>
                          handleChangeSelect(e, "legislation_id")
                        }
                        value={getValue(leg_ID, `[${0}]`, {})}
                        label="label"
                        id="id"
                        name="Legislation"
                        resetInput={resetInput}
                      />
                    </div>
                  </div>
                  <div className="filter-form-wrappper__location-form-group form-group">
                    <label
                      htmlFor="rule"
                      className="filter-form-wrappper__label"
                    >
                      Rule
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <SearchableDropdownSelect
                        placeholder={"Choose Legislation Rule"}
                        options={ruleList}
                        searchLoading={legislationRuleLoading}
                        handleChange={(val: any) =>
                          getLegislationRuleList(val, "", "")
                        }
                        handleClick={(e: any) =>
                          handleChangeSelect(e, "legislation_rule_id")
                        }
                        value={getValue(rule_ID, `[${0}]`, {})}
                        label="label"
                        id="id"
                        name="Legislation Rule"
                        resetInput={resetInput}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                {headerLoading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : getValue(headerList, `length`, 0) > 0 ? (
                  headerList.map((searchObj, index) => {
                    let selectedLevel =
                      getValue(searchObj, `group_level`, 0) > 0
                        ? getValue(
                            paramsObj,
                            `level${parseInt(
                              getValue(searchObj, `group_level`, "")
                            )}`,
                            ""
                          )
                        : "";
                    let currentSelectedItem = selectedLevel.split("_")[0];
                    let selectedValue =
                      getValue(
                        levelObj,
                        `[${getValue(searchObj, `id`, "")}].length`,
                        []
                      ) > 0 &&
                      getValue(
                        levelObj,
                        `[${getValue(searchObj, `id`, "")}]`,
                        []
                      ).filter(
                        (item: any) => item.id === parseInt(currentSelectedItem)
                      );
                    return (
                      <>
                        <div className={`d-flex cursor-pointer`}>
                          <div
                            className="position-relative form-group  align-items-center cursor-pointer mb-0"
                            key={`location-${index}`}
                          >
                            <label
                              htmlFor="country"
                              className="filter-form-wrappper__label"
                            >
                              {getValue(searchObj, `group_name`, "")}
                            </label>
                            <div>
                              <div className="filter-form-wrappper__location-input">
                                <SearchableDropdownSelect
                                  placeholder={`Choose ${getValue(
                                    searchObj,
                                    `group_name`,
                                    ""
                                  )}`}
                                  options={getValue(
                                    levelObj,
                                    `[${getValue(searchObj, `id`, "")}]`,
                                    []
                                  )}
                                  searchLoading={false}
                                  handleChange={(val: any) =>
                                    handleChange(
                                      val,
                                      getValue(searchObj, `id`, ""),
                                      getValue(searchObj, `group_level`, ""),
                                      index
                                    )
                                  }
                                  handleClick={(e: any) =>
                                    handleClickEntity(
                                      getValue(e, `id`, ""),
                                      getValue(searchObj, `id`, ""),
                                      getValue(searchObj, `group_level`, ""),
                                      index
                                    )
                                  }
                                  value={
                                    getValue(selectedValue, `length`, 0) > 0
                                      ? selectedValue[0]
                                      : ""
                                  }
                                  label="label"
                                  id="id"
                                  name={getValue(searchObj, `group_name`, "")}
                                  // removeClose
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </>
                    );
                  })
                ) : (
                  <>
                    {Object.keys(params).length !== 0 ? (
                      <>
                        <Notfound />
                      </>
                    ) : (
                      <Notfound />
                    )}
                  </>
                )}
              </div>
              <div className="">
                <div className="filter-form-wrappper__location-form-group form-group">
                  <label htmlFor="law" className="filter-form-wrappper__label">
                    Executor
                  </label>
                  <div className="filter-form-wrappper__location-input">
                    <SearchableDropdownSelect
                      placeholder={"Search Executor"}
                      options={executorList}
                      searchLoading={executorLoading}
                      handleChange={(val: any) => getExecutorList(val)}
                      handleClick={(e: any) => setSelectedExecutor(e)}
                      value={selectedExecutor}
                      label="label"
                      id="id"
                      name="Executor"
                    />
                  </div>
                </div>
                <div className="filter-form-wrappper__location-form-group form-group">
                  <label
                    htmlFor="legislation"
                    className="filter-form-wrappper__label"
                  >
                    Evaluator
                  </label>
                  <div className="filter-form-wrappper__location-input">
                    <SearchableDropdownSelect
                      placeholder={"Search Evaluator"}
                      options={evaluatorList}
                      searchLoading={EvaluatorLoading}
                      handleChange={(val: any) => getEvaluator(val)}
                      handleClick={(e: any) => setSelectedEvaluator(e)}
                      value={selectedEvaluator}
                      label="label"
                      id="id"
                      name="Evaluator"
                    />
                  </div>
                </div>
                <div className="filter-form-wrappper__location-form-group form-group">
                  <label htmlFor="rule" className="filter-form-wrappper__label">
                    Function Head
                  </label>
                  <div className="filter-form-wrappper__location-input">
                    <SearchableDropdownSelect
                      placeholder={"Search Function Head"}
                      options={FunctionHead}
                      searchLoading={FunctionHeadLoading}
                      handleChange={(val: any) => getFunctionHead(val)}
                      handleClick={(e: any) => setSelectedFunctionHead(e)}
                      value={selectedFunctionHead}
                      label="label"
                      id="id"
                      name="Function Head"
                    />
                  </div>
                </div>
              </div>
            </div>
            <ModalFooter>
              <button
                onClick={handleModal}
                className="ascent-button ascent-button--header-buttons ascent-button--primary"
              >
                Cancel
              </button>
              <button
                className="ascent-button  ascent-button--header-buttons ascent-button--secondary"
                onClick={handleSubmit}
                disabled={submitLoading}
              >
                {submitLoading ? "Please Wait..." : "Submit"}
              </button>
            </ModalFooter>
          </Modal>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default RepositoryMasterReports;
